import { render, staticRenderFns } from "./PaginaError.vue?vue&type=template&id=649b2cfc&scoped=true&"
import script from "./PaginaError.vue?vue&type=script&lang=js&"
export * from "./PaginaError.vue?vue&type=script&lang=js&"
import style0 from "./PaginaError.scss?vue&type=style&index=0&id=649b2cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649b2cfc",
  null
  
)

export default component.exports